import { createQueryKeys } from '@lukemorales/query-key-factory';
import {
  modeTranslate,
  overseaTranslate,
  TransFrom,
  TranslateMode,
  TranslateOptions,
} from 'services/api/overseaTranslate';

export const translates = createQueryKeys('translates', {
  overseaTranslate: (
    text: string,
    target: General.Language,
    from: TransFrom,
    region?: General.UpperCaseRegion,
  ) => ({
    queryKey: [text, target, from, region],
    queryFn: () => overseaTranslate(text, target, from, region),
  }),
  overseaTranslateBatch: (texts: string[], target: General.Language, from: TransFrom) => ({
    queryKey: [texts, target, from],
    queryFn: () => overseaTranslate(texts, target, from),
  }),
  modeTranslate: (
    text: string,
    target: General.Language,
    mode: TranslateMode,
    options?: TranslateOptions,
  ) => ({
    queryKey: [text, target, mode, options],
    queryFn: () => modeTranslate(text, target, mode, options),
  }),
});
